import script from "./issueList.component.vue?vue&type=script&lang=ts&setup=true"
export * from "./issueList.component.vue?vue&type=script&lang=ts&setup=true"

import "./issueList.component.vue?vue&type=style&index=0&id=536ecdac&lang=scss"

const __exports__ = script;

export default __exports__